import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Loader } from '@modulor/react';
import { useIsSC } from '../../../hooks/useIsSC';
import { GAME_FRAME } from '../../../constants/dataTestIds';
import { getDataTestAttributes } from '../../../utils/testing-locators';
import styles from './Iframe.module.css';

/**
 * func for adding camera and microphone access
 * currently used for 'live-solutions'
 * https://jira.pm.tech/browse/GAM-12212
 * @param {string} providerId
 * @returns {string}
 */
function getIframeAllowProp(providerId) {
  const allow = 'autoplay *; fullscreen *'; // allow="autoplay; fullscreen" doesn't work for fullscreen
  if (/live-solutions/.test(providerId)) {
    return allow + '; camera; microphone';
  }
  return allow;
}

const Iframe = ({
  isAggressiveMode,
  isMaximized,
  gameURL,
  scale,
  height,
  isEnabledAdaptiveIframe,
  providerId,
  ...props
}) => {
  const isSCCOM = useIsSC();
  return (
    <div
      className={classnames(
        isMaximized && styles.maximized,
        styles.iframe,
        !gameURL && styles.spinner,
        isAggressiveMode && styles.aggressiveMode,
        isEnabledAdaptiveIframe && styles.adaptive,
        isAggressiveMode && isSCCOM && styles.aggressiveMode_sccom
      )}
      style={{ height, ...scale }}
    >
      {gameURL ? (
        <iframe
          title="live-casino-game"
          src={gameURL}
          frameBorder="0"
          width="100%"
          height={height || '100%'}
          allow={getIframeAllowProp(providerId)}
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          {...getDataTestAttributes(GAME_FRAME)}
          {...props}
        />
      ) : (
        <Loader className={styles.loader} />
      )}
    </div>
  );
};

Iframe.propTypes = {
  gameURL: PropTypes.string.isRequired,
  scale: PropTypes.shape(),
  isMaximized: PropTypes.bool,
  isAggressiveMode: PropTypes.bool,
  providerId: PropTypes.string,
  isEnabledAdaptiveIframe: PropTypes.bool,
};
Iframe.defaultProps = {
  isMaximized: false,
  isAggressiveMode: false,
  scale: {},
  providerId: '',
  isEnabledAdaptiveIframe: false,
};

export default Iframe;
